//wizardShownAtSession - кука отображения попапа 2х факторки после релогина
//snProfile - кука с данными профайла клиента при регистрации через соцсети

module.exports = (fox, $) => {
    'use strict';

    const { 
        ENV_VAR_NAME_COOKIE,
        SESSION_VAR_NAME_COOKIE
    } = require('../../../../../common-components/GDPR-popups/constants');

    const DEFAULT_COOKIES_SETTINGS = {
        cookiesStrict: 0,
        cookiesPerformance: 1,
        cookiesFunctional: 1
    };

    const SESSION_VAR_NAME = SESSION_VAR_NAME_COOKIE;

    fox.registerWidget('MC_ConsentManaager', {

        configure() {
			this.registerOptions('', {
				consentsGetMethod: 'consent.list',
				analyticCookies: [],
				functionalCookies: [],
                cookiesPerformance: ['_ga', '_gid', '_gat_tracker0', '_hjIncludedInSample'],
                cookiesFunctional: [
                    'intercom-lou-sz14a447',
                    'intercom-session-sz14a447',
                    'intercom-id-sz14a447',
                    '_gat_intercomMessenger',

                    'wizardShownAtSession',
                    'landingDesign',
                    'snProfile',
                    'splashPromoBannerMobileDisabled',
                    'splashPromoBannerMobileDisabledNew',
                    'dashboardStepsClosed',
                    'storeEnabled',
                    'mc_lang'
                ],
                widgets: {
                    getSettingsApi: {
                        widget: 'Api',
                        method: 'consent.list'
                    }
                }
			});

			this.callParent('configure', arguments);
        },
        
        running() {
            let settings = this.getSettings();
            const gdprCookieWidget = fox.wom.selectFirst('@root #gdprCookieBanner');
            const isAcceptedByMember = (settings.cookiesStrict === 1);
            
            this.callParent('running', arguments);

            if (!settings) {
                settings = DEFAULT_COOKIES_SETTINGS;
            }

            // console.log('settings', settings);

            if (!isAcceptedByMember) {
                settings.cookiesFunctional = 1;
                settings.cookiesPerformance = 1;
            }

            if (Number(settings.cookiesStrict) === 1 && !localStorage.getItem(SESSION_VAR_NAME)) {
                gdprCookieWidget.saveToStorage();
            }

            if (Number(settings.cookiesFunctional) !== 1) {
                gdprCookieWidget.setOption('bannerType', 'functionalCookiesWarning');
                gdprCookieWidget.clearStorage();
                this.removeCookies('cookiesFunctional');
            }

            if (Number(settings.cookiesPerformance) !== 1) {
                this.removeCookies('cookiesPerformance');
            }

            if (!fox.site.member) {
                fox.each(settings, function(value, name) {
                    this.setSetting(name, value);
                }, this);
            }

            // if (!settings) {
            //     this.setSettings(DEFAULT_COOKIES_SETTINGS);
            //     settings = DEFAULT_COOKIES_SETTINGS;
            // }

            // if (settings.cookiesFunctional !== true) {
            //     gdprCookieWidget.setOption('bannerType', 'functionalCookiesWarning');
            //     gdprCookieWidget.clearStorage();
            //     this.removeCookies('cookiesFunctional');
            // }

            // if (settings.cookiesPerformance !== true) {
            //     this.removeCookies('cookiesPerformance');
            // }

            // ['cookiesPerformance', 'cookiesFunctional'].forEach(group => {
            //     this.removeCookies(group);
            // });
        },

        getApiSettings() {
            this.callParent('getApiSettings', arguments);
            this._apiInProgress = true;
            this.wait('@this', 'getConsentData', {prefix: fox.uniqid('getApiSettings_')}).then(() => {
                this._apiInProgress = false;
            })
        },

        check(consent) {
            const settings = this.getSettings();

            if (settings[consent]) {
                return fox.Promise.resolve(settings[consent]);
            }

            this.removeCookies(consent);

            return fox.Promise.reject({consent});
        },

        // check(consent) {
        //     if (!fox.site.member) {
        //         const settings = this.getSettings() || {};

        //         if (settings[consent]) {
        //             return fox.Promise.resolve(settings[consent]);
        //         }

        //         this.removeCookies(consent);

        //         return fox.Promise.reject({consent});
        //     }

        //     return this.checkMemberConsents(consent);
        // },

        checkMemberConsents(consent) {

            // if (this.memberConsentsIsLoaded()) {
            //     const value = this.apiData[consent];

            //     if (value) {
            //         return fox.Promise.resolve(value);
            //     }

            //     this.removeCookies(consent);
                
            //     return fox.Promise.reject({consent});
            // }

            // if (this.memberConsentsIsLoading()) {
            //     return this.wait('@this', 'getConsentData', {prefix: fox.uniqid('checkMemberConsents_')}).then(resp => {
            //         const data = resp.params;

            //         if (data[consent]) {
            //             return fox.Promise.resolve(data[consent]);
            //         }

            //         this.removeCookies(consent);
                
            //         return fox.Promise.reject({consent});
            //     });
            // }

            // return this._getApiData().then(response => {
            //     if (response[consent]) {
            //         return fox.Promise.resolve(response[consent]);
            //     }

            //     this.removeCookies(consent);
                
            //     return fox.Promise.reject({consent});
            // });
        },

        memberConsentsIsLoaded() {
            return fox.isSet(this.apiData);
        },

        memberConsentsIsLoading() {
            return this._apiInProgress === true;
        },

        getCookieType(name) {
			if (fox.inArray(this.getOption('cookiesPerformance'), name)) {
				return 'cookiesPerformance';
			}

			if (fox.inArray(this.getOption('cookiesFunctional'), name)) {
				return 'cookiesFunctional';
            }
            
            return false;
		},

		checkCookie(name) {
			const consent = this.getCookieType(name);

			if (!consent) {
                console.warn(`Cookie '${name}' doesn't described in cookies types`);
                
				return fox.Promise.reject({consent});
            }
            
            return this.check(consent);
        },
        
        setSettings(settings) {
            if (!fox.site.member) {
                fox.each(settings, function(value, name) {
                    this.setSetting(name, value);
                }, this);

                return fox.Promise.resolve(true);
            }

			var api = this.getApi('setSettingsApi', {method: this.getOption('consentSaveMethod')});
            // var params = this.getDigitSettings();

            return api.psend({aliases: settings}).then(() => {
                fox.setEnv(ENV_VAR_NAME_COOKIE, settings);
                
                return arguments;
            });
        },
        
        getSettings: function () {
            if (!fox.site.member) {
                return this._getCookieSettings();
            }

			return fox.getEnv(ENV_VAR_NAME_COOKIE);
        },

    }, 'Consent')
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/consent/widget/consent.es.js